const map = {
	"./dashboard-customers.page.tmpl.html": 1561,
	"./dashboard-invoices-form.page.tmpl.html": 1557,
	"./dashboard-invoices.page.tmpl.html": 4166,
	"./dashboard.page.tmpl.html": 3773,
	"./home.page.tmpl.html": 3314,
	"./login.page.tmpl.html": 7140,
	"./page-404.tmpl.html": 8992,
	"./page.tmpl.html": 499
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9701;